import React from 'react';
import { Table } from 'react-bootstrap';

import ReactPagination from '@components/reactPagination';

import CommonActions from '@app/SettingsLists/CommonActions';
import { dateTimeZone } from '@utils/utilFunctions';

const HolidayTable = ({
    currentPageData,
    showAlert,
    handleEditShow,
    pageCount,
    handlePageClick,
    filters,
}: any) => (
    <>
        <Table
            responsive="md"
            borderless
            className="mfnw__borderless_card-table mb-0 w-100"
        >
            <thead>
                <tr>
                    <th>NAME</th>
                    <th>DATE</th>
                    <th>CATEGORY</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                {currentPageData.map((item: any, index: number) => (
                    <tr key={index}>
                        <td
                            onClick={() =>
                                handleEditShow(item?.holiday_nano_id)
                            }
                            className="text-truncate text-capitalize"
                        >
                            {item?.name || '(N/A)'}
                        </td>
                        <td
                            onClick={() =>
                                handleEditShow(item?.holiday_nano_id)
                            }
                            className="text-truncate"
                        >
                            {item?.date ? dateTimeZone(item?.date) : '(N/A)'}
                        </td>
                        <td
                            onClick={() =>
                                handleEditShow(item?.holiday_nano_id)
                            }
                            className="text-truncate"
                        >
                            {item?.category || '(N/A)'}
                        </td>
                        <td>
                            <div className="d-flex align-items-center justify-content-end ">
                                <CommonActions
                                    item={item}
                                    showAlert={showAlert}
                                    handleEditShow={handleEditShow}
                                    nanoId={item?.holiday_nano_id}
                                    isUserList={false}
                                />
                            </div>
                        </td>
                    </tr>
                ))}
            </tbody>
        </Table>
        <div className="mt-3 mt-md-0">
            <ReactPagination
                currentPageData={currentPageData}
                pageCount={pageCount}
                handlePageClick={handlePageClick}
                filters={filters}
            />
        </div>
    </>
);

export default HolidayTable;
